<div class="modal email-modal fade show d-block" id="emailModal" tabindex="-1" aria-labelledby="emailModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header text-white">
        <h5 class="modal-title" id="emailModalLabel">
          <span class="modal-header-icon"></span>
          Sample Email Template
        </h5>
        <span class="btn-close-wrap">
          <button type="button" class="btn-close btn-close-white p-0 m-0" data-bs-dismiss="modal"
            (click)="onClose()"></button>
        </span>
      </div>

      <!-- Body -->
      <div class="modal-body" id="emailContent" #emailtemplatecontent>

        <h5>Subject</h5>
        <p>Medium - Inventory Module - Unable to update antigen record</p>

        <hr>

        <p class="fw-semibold text-dark">Hi ThinkBio Support Team,</p>

        <p class="text-dark">I would like to report an issue in the SIMISCO LIMS</p>

        <p>Severity : <strong>Medium</strong> <br>
          Module / Feature : <strong>Inventory - Antigen</strong><br>
          Location : <strong>Hayward</strong> <br>
          User Email ID : <strong>user&#64;simiscobio.com</strong></p>

        <h5>Issue Summary</h5>
        <p>I am unable to update an antigen record in the Inventory module.</p>

        <h5>Steps to Reproduce</h5>
        <ol>
          <li><span class="decimal">1.</span>Login to SIMISCO LIMS</li>
          <li><span class="decimal">2.</span>Go to Inventory &gt; Antigen</li>
          <li><span class="decimal">3.</span>Open an existing record</li>
          <li><span class="decimal">4.</span>Make the required changes</li>
          <li><span class="decimal">5.</span>Click Save</li>
        </ol>

        <p class="mb-2"><span class="text-success">EXPECTED RESULT :</span>
          The record should be updated successfully.
        </p>

        <p class="mb-2"><span class="text-primary">ACTUAL RESULT :</span>
          The changes are not getting saved / an error is displayed.
        </p>

        <p class="mb-2"><span class="text-danger">ERROR MESSAGE (if any) :</span>
          Please mention the exact error message here and attach screenshots for reference
        </p>

        <p class="text-dark mb-0"><strong class="fw-semibold">Your Name</strong><br>
          [Team / Department] | Contact Number</p>

      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button class="btn btn-primary m-0" (click)="copyTemplate()"><span class="copy-icon-white me-2"></span>Copy
          Template</button>
      </div>

    </div>
  </div>
</div>